import React, {  Fragment } from 'react';

import { EditWrapper, DiscountTypeButton } from '../../common/components';
import { DiscountItem, DiscountType, LoyaltyType } from '../../types';
import { useTranslation } from 'react-i18next';
import { useAccount } from '../../../settings/account/hooks';
import { getDefaultCountryCurrency } from '../../../helpers/currency';

interface DiscountTypeSelectorProps {
    discount: DiscountItem;
    index: number;
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
    isEditable: boolean;
    isMccOnly?: boolean;
}

const DiscountTypeSelector = (
    {
        discount,
        index,
        setFieldValue,
        isEditable,
        isMccOnly,
    }: DiscountTypeSelectorProps
) => {
    const { t } = useTranslation();
    const { account, isNotFound } = useAccount();

    if (isMccOnly) {
        // only show DiscountType.discountInPercentage
        return (
            <EditWrapper isEditable={isEditable}>
                <DiscountTypeButton
                    type="button"
                    onClick={() => {
                        setFieldValue(`discounts.${index}.type`, DiscountType.discountInPercentage);
                    }}
                    isSelected={discount.type === DiscountType.discountInPercentage}
                >
                    {t('marketing.campaign.discount_in_percentage')}
                </DiscountTypeButton>
            </EditWrapper>
        );
    }

    return (
        <Fragment>
            <EditWrapper isEditable={isEditable}>
                <DiscountTypeButton
                    type="button"
                    onClick={() => {
                        setFieldValue(`discounts.${index}.type`, DiscountType.discountInAmount);
                    }}
                    isSelected={discount.type === DiscountType.discountInAmount}
                >
                    {t('marketing.campaign.discount_in_currency', { currency: getDefaultCountryCurrency(account, ['NOK', 'SEK'], 'NOK') })}
                </DiscountTypeButton>
                <DiscountTypeButton
                    type="button"
                    onClick={() => {
                        setFieldValue(`discounts.${index}.type`, DiscountType.discountInPercentage);
                    }}
                    isSelected={discount.type === DiscountType.discountInPercentage}
                >
                    {t('marketing.campaign.discount_in_percentage')}
                </DiscountTypeButton>
                <DiscountTypeButton
                    type="button"
                    onClick={() => {
                        setFieldValue(`discounts.${index}.type`, DiscountType.amountBuyDiscount);
                    }}
                    isSelected={discount.type === DiscountType.amountBuyDiscount}
                >
                    {t('marketing.campaign.discount_amount')}
                </DiscountTypeButton>
                <DiscountTypeButton
                    type="button"
                    onClick={() => {
                        setFieldValue(`discounts.${index}.type`, DiscountType.fixedPriceDiscount);
                    }}
                    isSelected={discount.type === DiscountType.fixedPriceDiscount}
                >
                    {t('marketing.campaign.discount_price')}
                </DiscountTypeButton>
                <DiscountTypeButton
                    type="button"
                    onClick={() => {
                        setFieldValue(`discounts.${index}.type`, DiscountType.loyalty);
                    }}
                    isSelected={discount.type === DiscountType.loyalty}
                >
                    {t('marketing.campaign.loyalty_stamp_cards')}
                </DiscountTypeButton>
            </EditWrapper>
            {discount.type === DiscountType.loyalty && (
                <Fragment>
                    <EditWrapper isEditable={isEditable}>
                        <DiscountTypeButton
                            type="button"
                            onClick={() => {
                                setFieldValue(`discounts.${index}.loyaltyType`, LoyaltyType.visitAndSpending);
                            }}
                            isSelected={discount.loyaltyType === LoyaltyType.visitAndSpending}
                        >
                            {t('marketing.campaign.based_on_visits')}
                        </DiscountTypeButton>
                        <DiscountTypeButton
                            type="button"
                            onClick={() => {
                                setFieldValue(`discounts.${index}.loyaltyType`, LoyaltyType.productsBought);
                            }}
                            isSelected={discount.loyaltyType === LoyaltyType.productsBought}
                        >
                            {t('marketing.campaign.based_on_bought')}
                        </DiscountTypeButton>
                    </EditWrapper>
                </Fragment>
            )}
        </Fragment>
    );
};

export default DiscountTypeSelector;
